/**
 * Global Async functions
 */
export default {

  /**
   * Async Sleep Method
   * @param {} ms how long in milliseconds to sleep
   */
  async Sleep(ms) {
    return new Promise(resolve=>setTimeout(resolve,ms))
  }
}